import { XMarkIcon } from '@heroicons/react/24/solid'
import useTranslation from 'next-translate/useTranslation'
import { useEffect } from 'react'
import styles from './JobFilters.module.scss'

interface IProps {
  handleVisibleChange: any
  handleClearFilters: any
  isVisible: boolean
  children?: React.ReactNode
  className?: string
  totalCount?: number
}

const JobFiltersRwdWrapper = ({
  handleVisibleChange,
  handleClearFilters,
  isVisible,
  children,
  className,
  totalCount,
}: IProps) => {
  useEffect(() => {
    const body = document.querySelector('html')
    if (body) {
      if (isVisible) {
        body.classList.add('overflow-y-hidden')
      } else {
        body.classList.remove('overflow-y-hidden')
      }
    }
  }, [isVisible])

  const { t } = useTranslation('search')

  return (
    <div
      className={`${styles.filters__wrapper} ${
        isVisible ? styles['filters__wrapper--visible'] : ''
      }`}
    >
      <div
        className={`${styles['filters__filters-reject']}`}
        onClick={handleVisibleChange}
      />
      <div className={`${styles['filters__filters-wrapper']}`}>
        <div
          className={`overflow-y-scroll p-10 ${styles['filters__filters-scroll']}`}
        >
          <div className='flex justify-between mb-12'>
            <div className='font-normal text-4xl'>
              {t('common:filters_header')}
            </div>
            <div>
              <button
                type='button'
                className={styles.filters__close}
                onClick={handleVisibleChange}
                title={t('common:close')}
              >
                <XMarkIcon width={24} className='max-w-2xl' />
              </button>
            </div>
          </div>
          {children}
        </div>
        <div className='absolute left-0 bottom-0 right-0 flex gap-8 bg-white p-5'>
          <button
            type='button'
            className='flex-grow button-secondary whitespace-nowrap'
            onClick={handleClearFilters}
          >
            {t('search:remove_filters')}
          </button>
          <button
            type='button'
            className='flex-grow button-primary whitespace-nowrap'
            onClick={handleVisibleChange}
          >
            {`${t('search:apply_filters')} (${
              totalCount && totalCount > 100 ? '100+' : totalCount
            })`}
          </button>
        </div>
      </div>
    </div>
  )
}
export default JobFiltersRwdWrapper
